// extracted by mini-css-extract-plugin
export var addressFields = "_pg-0";
export var animationContainer = "_pg-1";
export var footer = "_pg-2";
export var lineItems = "_pg-3";
export var modalContent = "_pg-4";
export var orderName = "_pg-5";
export var strong = "_pg-6";
export var warning = "_pg-7";